export default [{
  path: '/usuarios-internos',
  component: {
    name: 'usuariosInternosBase',
    template: '<router-view />',
    meta: {
      resource: 'usuinterno',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'usuariosinternos',
    component: () => import('@/app-modulo/comuns/usuario-interno/UsuarioInternoView.vue'),
    meta: {
      resource: 'usuinterno',
      action: 'read',
      navActiveLink: 'usuariosinternos',
      pageTitle: 'Cadastro de Usuários Internos',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuariosinternos' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-usuario-interno',
    component: () => import('@/app-modulo/comuns/usuario-interno/shared/components/cadastro/UsuarioInterno.vue'),
    meta: {
      resource: 'usuinterno',
      action: 'create',
      navActiveLink: 'usuariosinternos',
      pageTitle: 'Cadastro de Usuários Internos',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuariosinternos' },
        },
        {
          text: 'Novo',
          to: { name: 'usuario-interno' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-usuario-interno',
    component: () => import('@/app-modulo/comuns/usuario-interno/shared/components/cadastro/UsuarioInterno.vue'),
    meta: {
      resource: 'usuinterno',
      action: 'update',
      navActiveLink: 'usuariosinternos',
      pageTitle: 'Cadastro de Usuários Internos',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuariosinternos' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-usuario-internos' },
          active: true,
        },
      ],
    },
  }],
}]
